import React from "react";
import { Flex, Text, VStack } from "@chakra-ui/react";
import { NumberInput } from "components";

interface ToothDiagnosisInputsProps {
  label: string;
  namePrefix: string;
}

const ToothDiagnosisInputs: React.FC<ToothDiagnosisInputsProps> = ({
  label,
  namePrefix
}) => {
  const inputFields = [
    { label: "M-Buc", name: `${namePrefix}MBuc` },
    { label: "Buccal", name: `${namePrefix}Buccal` },
    { label: "D-Buc", name: `${namePrefix}DBuc` },
    { label: "M-Ling/Pal", name: `${namePrefix}MLingPal` },
    { label: "Ling/Pal", name: `${namePrefix}LingPal` },
    { label: "D-Ling/Pal", name: `${namePrefix}DLingPal` }
  ];

  return (
    <VStack spacing="8px" flex="1">
      <Text alignSelf="flex-start">{label}</Text>
      <Flex gridGap="12px" alignSelf="flex-start" width="100%">
        {inputFields.map(field => (
          <VStack spacing="12px" flex="1" key={field.name}>
            <Text fontWeight="normal" color="gray.500">
              {field.label}
            </Text>
            <NumberInput
              placeholder="mm"
              name={field.name}
              min={0}
              getValueLabel={val => `${val} mm`}
              inputFieldProps={{
                _placeholder: {
                  textAlign: "center"
                },
                pr: 4,
                textAlign: "center"
              }}
            />
          </VStack>
        ))}
      </Flex>
    </VStack>
  );
};

export default ToothDiagnosisInputs;
